import { Grid, Button } from "@mui/material";
import { LoadingButton } from "@aclymatepackages/atoms";

// The Reauthenticate action re-authorizes the Plaid Item and can change
// which bank accounts are shared -- gated by canEdit the same way the
// data-gap Reconnect button is (see DataGapWarning.js), so a viewer sees
// Close instead of a button the server will now reject with a 403.
const ReauthenticationAction = ({
  doesRequireReauthentication,
  canEdit,
  isLoading,
  onReauthenticate,
  onClose
}) => (
  <Grid container spacing={2} justifyContent="center">
    {doesRequireReauthentication && canEdit ? (
      <Grid item>
        <LoadingButton
          isLoading={isLoading}
          onClick={onReauthenticate}
          color="primary"
          variant="contained"
          label="Reauthenticate"
        />
      </Grid>
    ) : (
      <Grid item>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </Grid>
    )}
  </Grid>
);

export default ReauthenticationAction;
